import { render, staticRenderFns } from "./CardExtraContent.vue?vue&type=template&id=78a9bc5c"
import script from "./CardExtraContent.vue?vue&type=script&lang=ts"
export * from "./CardExtraContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports